import { ThemeProvider, createTheme } from "@mui/material/styles";
import AppRoutes from "./Routes/Routes";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

const theme = createTheme();

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <AppRoutes />
      </div>
      <Analytics />
      <SpeedInsights />
    </ThemeProvider>
  );
}
